export default __webpack_public_path__ + "static/media/award-inactive.b678ff6f.png";